import { render, staticRenderFns } from "./yinjie.vue?vue&type=template&id=b0bacd66&"
import script from "./yinjie.vue?vue&type=script&lang=js&"
export * from "./yinjie.vue?vue&type=script&lang=js&"
import style0 from "./yinjie.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports